import S1 from "./SVG/S1";
import S2 from "./SVG/S2";
import S3 from "./SVG/S3";
import S4 from "./SVG/S4";
import S5 from "./SVG/S5";
import S6 from "./SVG/S6";
import S7 from "./SVG/S7";
import S8 from "./SVG/S8";

const PromotingContentData = [
  {
    title: "Pro ad constituto",
    text: "Ne usu illud albucius abhor reant, partiendo scriptorem mel ne.",
    svg: S1,
  },
  {
    title: "Eam commodo",
    text: "Fuisset intellegat delicatissimi ex mea. Cu probo integre nec.",
    svg: S2,
  },
  {
    title: "Reformidans eis",
    text: "Facer nostro causae ei sed. Vix ex quidam detraxit, vis ad nostro laoreet.",
    svg: S3,
  },
  {
    title: "Senserit sadipscing ut",
    text: "Wisi ornatus his at, viderer tractatos incorrupte has te.",
    svg: S4,
  },
  {
    title: "Facer nostro",
    text: "Ne usu illud albucius abhor reant, partiendo scriptorem mel ne.",
    svg: S5,
  },
  {
    title: "Vix quidam ex",
    text: "Fuisset intellegat delicatissimi ex mea. Cu probo integre nec.",
    svg: S6,
  },
  {
    title: "Wisi ornatus ut",
    text: "Facer nostro causae ei sed. Vix ex quidam detraxit, vis ad nostro laoreet.",
    svg: S7,
  },
  {
    title: "Illud albucius",
    text: "Wisi ornatus his at, viderer tractatos incorrupte has te.",
    svg: S8,
  },
];
export default PromotingContentData;
